import { render, staticRenderFns } from "./HostingKvmProvision.vue?vue&type=template&id=37a26598&scoped=true&"
import script from "./HostingKvmProvision.vue?vue&type=script&lang=js&"
export * from "./HostingKvmProvision.vue?vue&type=script&lang=js&"
import style0 from "./HostingKvmProvision.vue?vue&type=style&index=0&id=37a26598&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37a26598",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('37a26598')) {
      api.createRecord('37a26598', component.options)
    } else {
      api.reload('37a26598', component.options)
    }
    module.hot.accept("./HostingKvmProvision.vue?vue&type=template&id=37a26598&scoped=true&", function () {
      api.rerender('37a26598', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/services/hosting/kvm/HostingKvmProvision.vue"
export default component.exports